import { app } from './state.js';
import type { Route } from './types.js';

function parse(search: string): Route {
  const p = new URLSearchParams(search);
  const s = p.get('s');
  const c = p.get('c');
  const t = p.get('t');
  const i = p.get('i');
  if (!s) return { name: 'home' };
  if (!c) return { name: 'series', seriesId: s };
  const route: Route = { name: 'course', seriesId: s, courseId: c };
  if (t) route.t = Number(t) || 0;
  if (i) route.i = Number(i) | 0;
  return route;
}

function stringify(route: Route): string {
  const p = new URLSearchParams();
  if (route.name === 'series' || route.name === 'course') p.set('s', route.seriesId);
  if (route.name === 'course') {
    p.set('c', route.courseId);
    if (route.t != null && route.t > 0) p.set('t', route.t.toFixed(2));
    if (route.i != null && route.i >= 0) p.set('i', String(route.i));
  }
  const q = p.toString();
  return q ? `${location.pathname}?${q}` : location.pathname;
}

let suppressPush = false;

export function initRouter(): void {
  const applyFromLocation = () => {
    suppressPush = true;
    app.set((s) => ({ ...s, route: parse(location.search) }));
    suppressPush = false;
  };
  applyFromLocation();
  window.addEventListener('popstate', applyFromLocation);
  app.subscribe((s, prev) => {
    if (suppressPush) return;
    if (s.route === prev.route) return;
    const target = stringify(s.route);
    if (location.pathname + location.search !== target) {
      history.pushState(null, '', target);
    }
  });
}

export function navigate(route: Route): void {
  app.set((s) => ({ ...s, route }));
}

export function back(): void {
  const r = app.get().route;
  if (r.name === 'course') navigate({ name: 'series', seriesId: r.seriesId });
  else if (r.name === 'series') navigate({ name: 'home' });
}
